/**
 * @fileoverview Renders styled breadcrumbs (using 'react-breadcrumbs' module) from received props
 */

import React from 'react'
import { Breadcrumb } from 'react-breadcrumbs'
import { Breadcrumbs } from '../Breadcrumbs'

/**
 * Returns generated react component that contains rendered breadcrumbs based on received props
 *
 * @param {JSX.Element} props.icon Icon that will be displayed before first breadcrumb
 * @param {array<Object>} props.items Array of breadcrumbs that we want to render
 *
 * @param {string} props.items[].title Name of the path that will be displayed to the user
 * @param {string} props.items[].pathname URL that will be used for redirect on click
 *
 * @returns JSX.Element
 *
 * @example
 *  <BreadcrumbsRenderer
 *    icon={<Icon />}
 *    items={[{ title:'Campaigns', pathname: '/dashboard/campaigns' }]}
 *  />
 */
const BreadcrumbsRenderer = ({ icon, items }) => {
  const renderItems = items.map(({ title, pathname }, index) => (
    <Breadcrumb
      key={`BreadcrumbsRenderer-Breadcrumb-${title}-${index}`}
      data={{ title, pathname }}
    />
  ))

  return (
    <React.Fragment>
      <Breadcrumbs icon={icon} />
      {renderItems}
    </React.Fragment>
  )
}

export default BreadcrumbsRenderer



// WEBPACK FOOTER //
// ./src/Components/BreadcrumbsRenderer/BreadcrumbsRenderer.js